module.exports = __webpack_public_path__ + "img/MABB.c2325486.jpg";